import "./ContactSection.css"
import EmailButton from "../Button/EmailButton";

export default function ContactSection() {
    return (
        <section className="contact-footer-section" id="ContactSection">
                <div className="contact-footer-section-grid">
                    <div className="contact-footer-section-grid-item footer-text-1">
                        <p className="titulo_1">Cuéntanos tu historia,</p>
                        <p className="titulo_2">y la haremos realidad juntos</p>
                    </div>
                    <div className="contact-footer-section-grid-item footer-text-2">
                        <p>info@manapetita.com</p>
                        <p><a className="contact-link" href="https://www.instagram.com/manapetita/">@manapetita</a></p>
                        <p>(+34) 605 41 67 73</p>
                    </div>
                    <div className="contact-footer-section-grid-item footer-text-3">
                        <EmailButton
                            title="¡Esperamos tu mensaje!"
                            email="info@manapetita.com"
                            subject="Primer contacto"
                            body="Hola! Me gustaria tener una primera reunión, hablamos?"
                        />
                    </div>
            </div>
        </section>
    )
}